import componentShell from "./shell"
import NewsletterModal from "@/newsletter_modal/components/newsletter_modal"

export default componentShell(NewsletterModal)
